import type { FunctionComponent } from 'react';
import { HomeMd, UserMd } from '@property.com.au/ui-kit';
import type { Icons } from './SupplyDemandAndPerformanceGraphTooltip';
import type { PerformanceGraphHoverIcon } from '../types';

const mapIcons: Record<PerformanceGraphHoverIcon, Icons> = {
  HomeMd,
  UserMd,
};

export const SupplyDemandChartToolTipIcon: FunctionComponent<{
  iconName: PerformanceGraphHoverIcon;
}> = ({ iconName }) => {
  const MappedIcon = mapIcons[iconName];
  return (
    <MappedIcon
      style={{
        width: '17px',
        height: '17px',
      }}
    />
  );
};
